import * as i0 from '@angular/core';
import { EventEmitter, TemplateRef, Component, ChangeDetectionStrategy, ViewEncapsulation, ViewChildren, ViewChild, Input, Output, Directive, ElementRef, Inject, NgModule } from '@angular/core';
import * as i3 from '@angular/forms';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import * as i2 from '@niceltd/sol/text-input';
import { TextInputComponent, TextInputModule } from '@niceltd/sol/text-input';
import * as i4 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$1 from '@niceltd/sol/translation';
import { TranslationModule } from '@niceltd/sol/translation';
import { TemplatePortal } from '@angular/cdk/portal';
import { Subscription, merge } from 'rxjs';
import * as i1 from '@angular/cdk/overlay';
import { OverlayModule } from '@angular/cdk/overlay';
const _c0 = ["timeListContainer"];
const _c1 = ["timesList"];
const _c2 = a0 => ({
  "selected-list-item": a0
});
function TimePickerListComponent_ng_template_0_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 3, 4);
    i0.ɵɵlistener("keydown", function TimePickerListComponent_ng_template_0_div_2_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r6.handleKeyboardEvent($event));
    })("click", function TimePickerListComponent_ng_template_0_div_2_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r7);
      const time_r3 = restoredCtx.$implicit;
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.onClickTime(time_r3));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const time_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", i_r4 == 0 ? 0 : 1)("ngClass", i0.ɵɵpureFunction1(5, _c2, ctx_r2.selectedTimeString === time_r3));
    i0.ɵɵattribute("id", "time-option-" + (i_r4 + 1))("aria-label", time_r3);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(time_r3);
  }
}
function TimePickerListComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0, 1);
    i0.ɵɵtemplate(2, TimePickerListComponent_ng_template_0_div_2_Template, 4, 7, "div", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r0.timeListOptions);
  }
}
const _c3 = ["timePicker"];
const _c4 = ["timeOptionsContainer"];
const _c5 = ["timeOptions"];
function TimePickerComponent_ng_template_1__svg_svg_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 8);
    i0.ɵɵlistener("overlayStateChanged", function TimePickerComponent_ng_template_1__svg_svg_0_Template__svg_svg_overlayStateChanged_0_listener($event) {
      i0.ɵɵrestoreView(_r7);
      const ctx_r6 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r6.onOverlayChange($event));
    });
    i0.ɵɵelementStart(1, "title", 9);
    i0.ɵɵtext(2, "Input Check Icon");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "desc", 10);
    i0.ɵɵtext(4, "Input Check Icon Description Goes Here");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(5, "path", 11)(6, "path", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    const _r4 = i0.ɵɵreference(9);
    const _r2 = i0.ɵɵreference(4);
    i0.ɵɵproperty("solLibTimePicker", _r4)("solTextInput", _r2)("tabindex", ctx_r5.disabled ? -1 : 0);
  }
}
function TimePickerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, TimePickerComponent_ng_template_1__svg_svg_0_Template, 7, 3, "svg", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r0.alwaysOpen);
  }
}
const _c6 = a0 => ({
  "selected-item": a0
});
function TimePickerComponent_div_7_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16, 17);
    i0.ɵɵlistener("keydown", function TimePickerComponent_div_7_div_2_Template_div_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r13 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r13.handleKeyboardEvent($event));
    })("click", function TimePickerComponent_div_7_div_2_Template_div_click_0_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r14);
      const time_r10 = restoredCtx.$implicit;
      const ctx_r15 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r15.selectedTime(time_r10));
    });
    i0.ɵɵelementStart(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const time_r10 = ctx.$implicit;
    const i_r11 = ctx.index;
    const ctx_r9 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", i_r11 == 0 ? 0 : -1)("ngClass", i0.ɵɵpureFunction1(5, _c6, ctx_r9.selectedTimeString === time_r10));
    i0.ɵɵattribute("id", "time-option-" + (i_r11 + 1))("aria-label", time_r10);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(time_r10);
  }
}
function TimePickerComponent_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13, 14);
    i0.ɵɵtemplate(2, TimePickerComponent_div_7_div_2_Template, 4, 7, "div", 15);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.getOptions());
  }
}
const _c7 = ".sol-time-picker{display:flex;flex-direction:column;height:100%}.sol-time-picker .overlay-icon{outline:none;cursor:pointer}.sol-time-picker .overlay-icon:focus-visible{outline:1px solid #5804ff;outline-offset:2px}.sol-time-picker .time-list-container{width:100%;cursor:pointer;background-color:var(--color-button-basic-normal);overflow-y:scroll}.sol-time-picker .time-list-container .time-options{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body4-font-weight);padding:.625rem .75rem;margin:4px;border-radius:4px}.sol-time-picker .time-list-container .time-options:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.sol-time-picker .time-list-container .time-options.selected-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container{border-color:var(--color-interface-border1);border-width:1px;border-style:solid;max-height:12.25rem;padding:.25rem .25rem .25rem .5rem;font-weight:var(--typography-opensans-body-body4-font-weight);cursor:pointer;background-color:var(--color-button-basic-normal);border-radius:4px;width:100%;overflow-y:scroll;box-shadow:0 8px 12px 1px #ab535333}.time-options-list-container .time-options-list{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body1-font-size);color:var(--color-interface-text700);padding:.6875rem 1rem;border-radius:4px;margin-bottom:.25rem}.time-options-list-container .time-options-list:last-child{margin-bottom:0}.time-options-list-container .time-options-list:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.time-options-list-container .time-options-list.selected-list-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n";
class TimePickerListComponent {
  constructor(cdr) {
    this.cdr = cdr;
    this.timeListOptions = [];
    this.overlayStatus = false;
    this.closed = new EventEmitter();
    this.selectedListTime = new EventEmitter();
    this.selectedTimeString = '';
    this.currentIndex = 0;
  }
  ngOnChanges() {
    if (this.overlayStatus) {
      this.currentIndex = 0;
    }
  }
  onClickTime(item) {
    this.selectedTimeString = item;
    this.selectedListTime.emit(item);
    this.closed.emit();
  }
  handleKeyboardEvent(event) {
    event.preventDefault();
    this.cdr.detectChanges();
    if (event.shiftKey && event.key === 'Tab') {
      this.currentIndex = 0;
      this.closed.emit();
    } else if (event.key === 'Tab') {
      this.currentIndex = 0;
      this.closed.emit();
    } else if (event.key === 'ArrowDown') {
      this.currentIndex++;
      if (this.currentIndex >= this.timeListOptions.length) {
        this.currentIndex = 0;
      }
      this.timesListEl.toArray()[this.currentIndex]?.nativeElement.focus();
      if (this.timesListEl && this.timeListContainer) {
        const focusedRect = this.timesListEl.toArray()[this.currentIndex].nativeElement.getBoundingClientRect();
        const containerRect = this.timeListContainer.nativeElement.getBoundingClientRect();
        const containerBottom = containerRect.top + containerRect.height;
        const buffer = 10;
        if (focusedRect.bottom + 1 > containerBottom) {
          const scrollPosition = this.timeListContainer.nativeElement.scrollTop + (focusedRect.bottom - containerBottom) + buffer;
          this.timeListContainer.nativeElement.scrollTo({
            top: scrollPosition
          });
        }
      }
    } else if (event.key === 'ArrowUp') {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.timeListOptions.length - 1;
      }
      this.timesListEl.toArray()[this.currentIndex]?.nativeElement.focus();
      const focusedRect = this.timesListEl.toArray()[this.currentIndex]?.nativeElement.getBoundingClientRect();
      const containerRect = this.timeListContainer?.nativeElement.getBoundingClientRect();
      const containerTop = containerRect?.top;
      const buffer = 10;
      if (focusedRect?.top - 1 < containerTop) {
        const scrollPosition = this.timeListContainer?.nativeElement.scrollTop - (containerTop - focusedRect?.top) - buffer;
        this.timeListContainer?.nativeElement.scrollTo({
          top: scrollPosition
        });
      }
    } else if (event.key === 'Escape') {
      this.currentIndex = 0;
      this.closed.emit();
    } else if (event.key === 'Enter') {
      const timeItem = this.timesListEl.toArray()[this.currentIndex]?.nativeElement.textContent;
      this.onClickTime(timeItem);
      this.currentIndex = 0;
    }
  }
  static {
    this.ɵfac = function TimePickerListComponent_Factory(t) {
      return new (t || TimePickerListComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerListComponent,
      selectors: [["sol-time-picker-list"]],
      viewQuery: function TimePickerListComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(TemplateRef, 5);
          i0.ɵɵviewQuery(_c0, 5);
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templateRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeListContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timesListEl = _t);
        }
      },
      inputs: {
        timeListOptions: "timeListOptions",
        overlayStatus: "overlayStatus",
        selectedTimeString: "selectedTimeString"
      },
      outputs: {
        closed: "closed",
        selectedListTime: "selectedListTime"
      },
      features: [i0.ɵɵNgOnChangesFeature],
      decls: 1,
      vars: 0,
      consts: [[1, "time-options-list-container"], ["timeListContainer", ""], ["class", "time-options-list", 3, "tabindex", "ngClass", "keydown", "click", 4, "ngFor", "ngForOf"], [1, "time-options-list", 3, "tabindex", "ngClass", "keydown", "click"], ["timesList", ""]],
      template: function TimePickerListComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵtemplate(0, TimePickerListComponent_ng_template_0_Template, 3, 1, "ng-template");
        }
      },
      dependencies: [i4.NgClass, i4.NgForOf],
      styles: [".sol-time-picker{display:flex;flex-direction:column;height:100%}.sol-time-picker .overlay-icon{outline:none;cursor:pointer}.sol-time-picker .overlay-icon:focus-visible{outline:1px solid #5804ff;outline-offset:2px}.sol-time-picker .time-list-container{width:100%;cursor:pointer;background-color:var(--color-button-basic-normal);overflow-y:scroll}.sol-time-picker .time-list-container .time-options{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body4-font-weight);padding:.625rem .75rem;margin:4px;border-radius:4px}.sol-time-picker .time-list-container .time-options:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.sol-time-picker .time-list-container .time-options.selected-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container{border-color:var(--color-interface-border1);border-width:1px;border-style:solid;max-height:12.25rem;padding:.25rem .25rem .25rem .5rem;font-weight:var(--typography-opensans-body-body4-font-weight);cursor:pointer;background-color:var(--color-button-basic-normal);border-radius:4px;width:100%;overflow-y:scroll;box-shadow:0 8px 12px 1px #ab535333}.time-options-list-container .time-options-list{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body1-font-size);color:var(--color-interface-text700);padding:.6875rem 1rem;border-radius:4px;margin-bottom:.25rem}.time-options-list-container .time-options-list:last-child{margin-bottom:0}.time-options-list-container .time-options-list:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.time-options-list-container .time-options-list.selected-list-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerListComponent, [{
    type: Component,
    args: [{
      selector: 'sol-time-picker-list',
      template: `
    <ng-template>
      <div class="time-options-list-container" #timeListContainer>
        <div
          #timesList
          *ngFor="let time of timeListOptions; let i = index"
          class="time-options-list"
          [attr.id]="'time-option-' + (i + 1)"
          (keydown)="handleKeyboardEvent($event)"
          [tabindex]="i == 0 ? 0 : 1"
          (click)="onClickTime(time)"
          [ngClass]="{ 'selected-list-item': selectedTimeString === time }"
          [attr.aria-label]="time"
        >
          <span>{{ time }}</span>
        </div>
      </div>
    </ng-template>
  `,
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      styles: [".sol-time-picker{display:flex;flex-direction:column;height:100%}.sol-time-picker .overlay-icon{outline:none;cursor:pointer}.sol-time-picker .overlay-icon:focus-visible{outline:1px solid #5804ff;outline-offset:2px}.sol-time-picker .time-list-container{width:100%;cursor:pointer;background-color:var(--color-button-basic-normal);overflow-y:scroll}.sol-time-picker .time-list-container .time-options{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body4-font-weight);padding:.625rem .75rem;margin:4px;border-radius:4px}.sol-time-picker .time-list-container .time-options:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.sol-time-picker .time-list-container .time-options.selected-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container{border-color:var(--color-interface-border1);border-width:1px;border-style:solid;max-height:12.25rem;padding:.25rem .25rem .25rem .5rem;font-weight:var(--typography-opensans-body-body4-font-weight);cursor:pointer;background-color:var(--color-button-basic-normal);border-radius:4px;width:100%;overflow-y:scroll;box-shadow:0 8px 12px 1px #ab535333}.time-options-list-container .time-options-list{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body1-font-size);color:var(--color-interface-text700);padding:.6875rem 1rem;border-radius:4px;margin-bottom:.25rem}.time-options-list-container .time-options-list:last-child{margin-bottom:0}.time-options-list-container .time-options-list:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.time-options-list-container .time-options-list.selected-list-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }], {
    timesListEl: [{
      type: ViewChildren,
      args: ['timesList']
    }],
    templateRef: [{
      type: ViewChild,
      args: [TemplateRef]
    }],
    timeListContainer: [{
      type: ViewChild,
      args: ['timeListContainer']
    }],
    timeListOptions: [{
      type: Input
    }],
    overlayStatus: [{
      type: Input
    }],
    closed: [{
      type: Output
    }],
    selectedListTime: [{
      type: Output
    }],
    selectedTimeString: [{
      type: Input
    }]
  });
})();
const DEFAULTS = {
  steps: 15,
  timeFormat: 'hh:mm A',
  getDefaultMinTime: new Date(new Date().setHours(0, 0, 0, 0)),
  getDefaultMaxTime: new Date(new Date().setHours(23, 59, 0, 0))
};
class TimePickerDirective {
  constructor(overlay, elementRef, viewContainerRef) {
    this.overlay = overlay;
    this.elementRef = elementRef;
    this.viewContainerRef = viewContainerRef;
    this.isTimePickerOpen = false;
    this.timepickerClosingActionsSub = Subscription.EMPTY;
    this.overlayStateChanged = new EventEmitter();
  }
  toggleTimePicker() {
    if (this.isTimePickerOpen) {
      this.destroyTimePicker();
    } else {
      this.openTimepicker();
    }
  }
  openTimepicker() {
    const textinputEl = this.textInput.elementRef.nativeElement;
    this.isTimePickerOpen = true;
    this.overlayRef = this.overlay.create({
      width: textinputEl.offsetWidth,
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-transparent-backdrop',
      scrollStrategy: this.overlay.scrollStrategies.close(),
      panelClass: 'timepicker-wrapper',
      positionStrategy: this.overlay.position().flexibleConnectedTo(this.textInput.elementRef).withPositions([{
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 1,
        offsetX: 0
      }, {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
        offsetY: -8,
        offsetX: 0
      }])
    });
    const templatePortal = new TemplatePortal(this.timepickerPanel.templateRef, this.viewContainerRef);
    this.overlayRef.attach(templatePortal);
    this.timepickerClosingActionsSub = this.timepickerClosingActions().subscribe(() => this.destroyTimePicker());
    setTimeout(() => {
      document.querySelector('#time-option-1')?.focus();
    }, 100);
    this.overlayStateChanged.emit(this.isTimePickerOpen);
  }
  timepickerClosingActions() {
    const backdropClick$ = this.overlayRef.backdropClick();
    const detachment$ = this.overlayRef.detachments();
    const timepickerClosed = this.timepickerPanel.closed;
    return merge(backdropClick$, detachment$, timepickerClosed);
  }
  destroyTimePicker() {
    if (!this.overlayRef || !this.isTimePickerOpen) {
      return;
    }
    this.timepickerClosingActionsSub.unsubscribe();
    this.isTimePickerOpen = false;
    this.overlayRef.detach();
    this.overlayStateChanged.emit(this.isTimePickerOpen);
  }
  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
    }
  }
  static {
    this.ɵfac = function TimePickerDirective_Factory(t) {
      return new (t || TimePickerDirective)(i0.ɵɵdirectiveInject(i1.Overlay), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef));
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: TimePickerDirective,
      selectors: [["", "solLibTimePicker", ""]],
      hostBindings: function TimePickerDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function TimePickerDirective_click_HostBindingHandler() {
            return ctx.toggleTimePicker();
          })("keydown.enter", function TimePickerDirective_keydown_enter_HostBindingHandler() {
            return ctx.toggleTimePicker();
          });
        }
      },
      inputs: {
        timepickerPanel: [i0.ɵɵInputFlags.None, "solLibTimePicker", "timepickerPanel"],
        textInput: [i0.ɵɵInputFlags.None, "solTextInput", "textInput"]
      },
      outputs: {
        overlayStateChanged: "overlayStateChanged"
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerDirective, [{
    type: Directive,
    args: [{
      selector: '[solLibTimePicker]',
      host: {
        '(click)': 'toggleTimePicker()',
        '(keydown.enter)': 'toggleTimePicker()'
      }
    }]
  }], () => [{
    type: i1.Overlay
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ViewContainerRef
  }], {
    timepickerPanel: [{
      type: Input,
      args: ['solLibTimePicker']
    }],
    textInput: [{
      type: Input,
      args: ['solTextInput']
    }],
    overlayStateChanged: [{
      type: Output
    }]
  });
})();
class TimePickerComponent {
  constructor(cdr, elementRef, translationService) {
    this.cdr = cdr;
    this.translationService = translationService;
    this.disabled = false;
    this.disableTextInput = false;
    this.alwaysOpen = false;
    this.invalid = this.translationService.getTranslation('invalidTime');
    this.timeChanged = new EventEmitter();
    this.timeOptions = [];
    this.searchOptions = [];
    this.selectedTimeString = '';
    this.latestSearch = '';
    this.showOverlay = false;
    this.currentIndex = 0;
    this._controlValueAccessorChangeFn = _ => {};
    this._controlValueAccessorTouchedFn = () => {};
    this.focusInput = () => {
      this.elementRef.nativeElement.querySelector('.sol-input').focus();
    };
    this.elementRef = elementRef;
    this.date_object = this.minTime;
    this.initialize();
  }
  writeValue(obj) {
    if (obj) {
      this.date_object = obj;
      this.selectedTimeString = this.convertFromDateToString(obj);
      this.getErrorMessage();
    } else {
      this.date_object = null;
      this.selectedTimeString = '';
    }
    this.cdr.detectChanges();
  }
  registerOnChange(fn) {
    this._controlValueAccessorChangeFn = fn;
  }
  registerOnTouched(fn) {
    this._controlValueAccessorTouchedFn = fn;
  }
  onTextInputBlur() {
    this._controlValueAccessorTouchedFn();
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }
  ngOnChanges() {
    this.initialize();
  }
  initialize() {
    this.steps = this.steps === undefined ? DEFAULTS.steps : this.steps < 1 ? 1 : this.steps > 59 ? 59 : this.steps;
    this.format = this.format === undefined ? DEFAULTS.timeFormat : this.format;
    this.minTime = this.minTime === undefined ? DEFAULTS.getDefaultMinTime : this.minTime;
    this.maxTime = this.maxTime === undefined ? DEFAULTS.getDefaultMaxTime : this.getTimeObject(this.maxTime);
    this.populateTimeOptions();
  }
  getTimeObject(timeObject) {
    if (timeObject.toDateString() !== this.minTime.toDateString()) {
      timeObject.setFullYear(this.minTime.getFullYear(), this.minTime.getMonth(), this.minTime.getDate());
      return timeObject;
    }
    return timeObject;
  }
  populateTimeOptions() {
    const startTime = new Date(this.minTime);
    const endTime = new Date(this.maxTime);
    this.timeOptions = [];
    while (startTime < endTime) {
      const minutes = startTime.getMinutes();
      const options = this.generateTimeOptions(startTime);
      this.timeOptions.push(options);
      startTime.setMinutes(minutes + this.steps);
    }
  }
  generateTimeOptions(dateObject) {
    let timeString = '';
    if (dateObject instanceof Date) {
      let hours = dateObject.getHours();
      const minutes = dateObject.getMinutes();
      let ampmTimeFormat = "AM" /* TimeDurationAMPM.AM */;
      if (this.format === "hh:mm A" /* TimeFormats.tweleveHours */.toString() || this.format === "hh:mm:ss A" /* TimeFormats.tweleveHoursWithSec */.toString()) {
        if (hours === 0) {
          hours = 12;
          ampmTimeFormat = "AM" /* TimeDurationAMPM.AM */;
        } else {
          ampmTimeFormat = hours > 11 ? "PM" /* TimeDurationAMPM.PM */ : "AM" /* TimeDurationAMPM.AM */;
        }
        hours = hours > 12 ? hours - 12 : hours;
        if (this.format === "hh:mm:ss A" /* TimeFormats.tweleveHoursWithSec */.toString()) {
          timeString = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + '00' + ' ' + ampmTimeFormat;
          return timeString;
        } else {
          timeString = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ' ' + ampmTimeFormat;
          return timeString;
        }
      } else if (this.format === "hh:mm:ss" /* TimeFormats.twentyFourHoursWithSec */.toString()) {
        timeString = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2) + ':' + '00';
        return timeString;
      } else {
        timeString = ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2);
        return timeString;
      }
    }
    return timeString;
  }
  getErrorMessage() {
    if (this.textInputEl && document.activeElement !== this.textInputEl.textInput.nativeElement && this.latestSearch !== '' && !this.timeOptions.includes(this.selectedTimeString)) {
      return this.invalid;
    } else if (!this.timeOptions.includes(this.selectedTimeString) && document.activeElement !== this.textInputEl?.textInput.nativeElement && this.selectedTimeString !== '') {
      return this.invalid;
    }
    return null;
  }
  selectedTime(timeString) {
    this.selectedTimeString = timeString;
    this.date_object = this.convertFromStringToDate(timeString);
    this._controlValueAccessorChangeFn(this.date_object);
    this.timeChanged.emit(this.date_object);
    this.cdr.detectChanges();
  }
  convertFromDateToString(obj) {
    const timeString = this.generateTimeOptions(obj);
    return timeString;
  }
  convertFromStringToDate(time) {
    const date = new Date(this.minTime);
    const date_string = date.toDateString() + ' ' + time;
    this.date_object = new Date(Date.parse(date_string));
    return this.date_object;
  }
  onChange(val) {
    const searchValue = val;
    this.date_object = this.convertFromStringToDate(searchValue);
    this.latestSearch = searchValue;
    let results = [];
    if (searchValue.length > 0) {
      results = this.search(searchValue);
    }
    if (this.latestSearch === '') {
      this.date_object = null;
      this.searchOptions = this.timeOptions;
    } else {
      this.searchOptions = results;
    }
    this._controlValueAccessorChangeFn(this.date_object);
  }
  search(str) {
    const results = [];
    const val = str.toLowerCase();
    const val2 = String(Number(str) + 12).toLowerCase();
    for (let i = 0; i < this.timeOptions.length; i++) {
      if (this.timeOptions[i].toLowerCase().indexOf(val) > -1 || this.timeOptions[i].toLowerCase().indexOf(val2) > -1) {
        results.push(this.timeOptions[i]);
      }
    }
    return results;
  }
  getOptions() {
    if (this.selectedTimeString !== '' && this.latestSearch !== '') {
      if (this.searchOptions.length === 0) {
        this.searchOptions.push('No Results');
        return this.searchOptions;
      } else {
        return this.searchOptions;
      }
    } else {
      return this.timeOptions;
    }
  }
  onOverlayChange(val) {
    this.showOverlay = val;
  }
  handleKeyboardEvent(event) {
    this.cdr.detectChanges();
    if (event.key === 'Tab' && event.shiftKey) {
      event.preventDefault();
      this.elementRef.nativeElement.querySelector('.sol-input').focus();
      this.currentIndex = 0;
    } else if (event.key === 'Tab') {
      this.currentIndex = 0;
      this.timesOptionEl.toArray()[this.currentIndex].nativeElement.focus();
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.currentIndex++;
      if (this.currentIndex >= this.timeOptions.length) {
        this.currentIndex = 0;
      }
      this.timesOptionEl.toArray()[this.currentIndex].nativeElement.focus();
      const focusedEl = this.timesOptionEl.toArray()[this.currentIndex].nativeElement.getBoundingClientRect();
      const optionsContainer = this.timeOptionsContainer.nativeElement.getBoundingClientRect();
      const containerBottom = optionsContainer.top + optionsContainer.height;
      const buffer = 10;
      if (focusedEl.bottom + 1 > containerBottom) {
        const scrollPosition = this.timeOptionsContainer.nativeElement.scrollTop + (focusedEl.bottom - containerBottom) + buffer;
        this.timeOptionsContainer.nativeElement.scrollTo({
          top: scrollPosition
        });
      }
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.timesOptionEl.length - 1;
      }
      this.timesOptionEl.toArray()[this.currentIndex].nativeElement.focus();
      const focusedEl = this.timesOptionEl.toArray()[this.currentIndex].nativeElement.getBoundingClientRect();
      const optonsContainer = this.timeOptionsContainer.nativeElement.getBoundingClientRect();
      const containerTop = optonsContainer.top;
      const buffer = 10;
      if (focusedEl.top - 1 < containerTop) {
        const scrollPosition = this.timeOptionsContainer.nativeElement.scrollTop - (containerTop - focusedEl.top) - buffer;
        this.timeOptionsContainer.nativeElement.scrollTo({
          top: scrollPosition
        });
      }
    } else if (event.key === 'Escape') {
      this.currentIndex = 0;
      this.elementRef.nativeElement.querySelector('.sol-input').focus();
    } else if (event.key === 'Enter') {
      const timeItem = this.timesOptionEl.toArray()[this.currentIndex].nativeElement.textContent;
      this.timesOptionEl.toArray()[this.currentIndex].nativeElement.blur();
      this.currentIndex = 0;
      this.selectedTime(timeItem);
    }
  }
  static {
    this.ɵfac = function TimePickerComponent_Factory(t) {
      return new (t || TimePickerComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(i1$1.TranslationService));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: TimePickerComponent,
      selectors: [["sol-time-picker"]],
      viewQuery: function TimePickerComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(TextInputComponent, 5);
          i0.ɵɵviewQuery(TimePickerListComponent, 5);
          i0.ɵɵviewQuery(_c5, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timePicker = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timeOptionsContainer = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.textInputEl = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timePickerList = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.timesOptionEl = _t);
        }
      },
      inputs: {
        format: "format",
        minTime: "minTime",
        maxTime: "maxTime",
        steps: "steps",
        disabled: "disabled",
        disableTextInput: "disableTextInput",
        alwaysOpen: "alwaysOpen"
      },
      outputs: {
        timeChanged: "timeChanged"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TimePickerComponent,
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 10,
      vars: 15,
      consts: [[1, "sol-time-picker"], ["overlayIcon", ""], [3, "trailingIcon", "labelText", "disabled", "readonly", "errorMessageText", "ngModel", "placeholderText", "ngModelChange", "valueChange", "blur"], ["inputText", ""], ["class", "time-list-container", 4, "ngIf"], [3, "timeListOptions", "overlayStatus", "selectedTimeString", "selectedListTime", "closed"], ["openOverlay", ""], ["class", "overlay-icon", "width", "20", "tabindex", "0", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", "id", "overLayIcon", 3, "solLibTimePicker", "solTextInput", "tabindex", "overlayStateChanged", 4, "ngIf"], ["width", "20", "tabindex", "0", "height", "20", "viewBox", "0 0 20 20", "fill", "none", "xmlns", "http://www.w3.org/2000/svg", "id", "overLayIcon", 1, "overlay-icon", 3, "solLibTimePicker", "solTextInput", "tabindex", "overlayStateChanged"], ["id", "tickLogo"], ["id", "tickLogoDesc"], ["d", "M10 10V6.65C10 6.0975 9.5525 5.65 9 5.65C8.4475 5.65 8 6.0975 8 6.65V11.31C8 11.78 8.78 12 9.25 12H15.25C15.8025 12 16.25 11.5525 16.25 11C16.25 10.4475 15.8025 10 15.25 10H10Z", "fill", "#3F5C69"], ["d", "M10 0C4.47688 0 0 4.47688 0 10C0 15.5231 4.47688 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47688 15.5231 0 10 0ZM10 18C5.58188 18 2 14.4181 2 10C2 5.58188 5.58188 2 10 2C14.4181 2 18 5.58188 18 10C18 14.4181 14.4181 18 10 18Z", "fill", "#3F5C69"], [1, "time-list-container"], ["timeOptionsContainer", ""], ["class", "time-options", 3, "tabindex", "ngClass", "keydown", "click", 4, "ngFor", "ngForOf"], [1, "time-options", 3, "tabindex", "ngClass", "keydown", "click"], ["timeOptions", ""]],
      template: function TimePickerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵtemplate(1, TimePickerComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementStart(3, "sol-text-input", 2, 3);
          i0.ɵɵtwoWayListener("ngModelChange", function TimePickerComponent_Template_sol_text_input_ngModelChange_3_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.selectedTimeString, $event) || (ctx.selectedTimeString = $event);
            return $event;
          });
          i0.ɵɵlistener("valueChange", function TimePickerComponent_Template_sol_text_input_valueChange_3_listener($event) {
            return ctx.onChange($event);
          })("blur", function TimePickerComponent_Template_sol_text_input_blur_3_listener() {
            return ctx.onTextInputBlur();
          });
          i0.ɵɵpipe(5, "translate");
          i0.ɵɵpipe(6, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, TimePickerComponent_div_7_Template, 3, 1, "div", 4);
          i0.ɵɵelementStart(8, "sol-time-picker-list", 5, 6);
          i0.ɵɵlistener("selectedListTime", function TimePickerComponent_Template_sol_time_picker_list_selectedListTime_8_listener($event) {
            return ctx.selectedTime($event);
          })("closed", function TimePickerComponent_Template_sol_time_picker_list_closed_8_listener() {
            return ctx.focusInput();
          });
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          const _r1 = i0.ɵɵreference(2);
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("labelText", i0.ɵɵpipeBind1(5, 11, "enterTime"));
          i0.ɵɵpropertyInterpolate("placeholderText", i0.ɵɵpipeBind1(6, 13, "selectTime"));
          i0.ɵɵproperty("trailingIcon", _r1)("disabled", ctx.disabled)("readonly", ctx.disableTextInput)("errorMessageText", !ctx.showOverlay ? ctx.getErrorMessage() : null);
          i0.ɵɵtwoWayProperty("ngModel", ctx.selectedTimeString);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.alwaysOpen);
          i0.ɵɵadvance();
          i0.ɵɵproperty("timeListOptions", ctx.getOptions())("overlayStatus", ctx.showOverlay)("selectedTimeString", ctx.selectedTimeString);
        }
      },
      dependencies: [i2.TextInputComponent, i3.NgControlStatus, i3.NgModel, i4.NgClass, i4.NgForOf, i4.NgIf, TimePickerDirective, TimePickerListComponent, i1$1.TranslationPipe],
      styles: [_c7],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerComponent, [{
    type: Component,
    args: [{
      selector: 'sol-time-picker',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: TimePickerComponent,
        multi: true
      }],
      template: "<div class=\"sol-time-picker\">\n  <ng-template #overlayIcon>\n    <svg\n      class=\"overlay-icon\"\n      width=\"20\"\n      tabindex=\"0\"\n      height=\"20\"\n      *ngIf=\"!alwaysOpen\"\n      (overlayStateChanged)=\"onOverlayChange($event)\"\n      [solLibTimePicker]=\"openOverlay\"\n      [solTextInput]=\"inputText\"\n      viewBox=\"0 0 20 20\"\n      [tabindex]=\"disabled ? -1 : 0\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n      id=\"overLayIcon\"\n    >\n      <title id=\"tickLogo\">Input Check Icon</title>\n      <desc id=\"tickLogoDesc\">Input Check Icon Description Goes Here</desc>\n      <path\n        d=\"M10 10V6.65C10 6.0975 9.5525 5.65 9 5.65C8.4475 5.65 8 6.0975 8 6.65V11.31C8 11.78 8.78 12 9.25 12H15.25C15.8025 12 16.25 11.5525 16.25 11C16.25 10.4475 15.8025 10 15.25 10H10Z\"\n        fill=\"#3F5C69\"\n      />\n      <path\n        d=\"M10 0C4.47688 0 0 4.47688 0 10C0 15.5231 4.47688 20 10 20C15.5231 20 20 15.5231 20 10C20 4.47688 15.5231 0 10 0ZM10 18C5.58188 18 2 14.4181 2 10C2 5.58188 5.58188 2 10 2C14.4181 2 18 5.58188 18 10C18 14.4181 14.4181 18 10 18Z\"\n        fill=\"#3F5C69\"\n      />\n    </svg>\n  </ng-template>\n  <sol-text-input\n    #inputText\n    [trailingIcon]=\"overlayIcon\"\n    labelText=\"{{ 'enterTime' | translate }}\"\n    [disabled]=\"disabled\"\n    [readonly]=\"disableTextInput\"\n    [errorMessageText]=\"!showOverlay ? getErrorMessage() : null\"\n    [(ngModel)]=\"selectedTimeString\"\n    (valueChange)=\"onChange($event)\"\n    placeholderText=\"{{ 'selectTime' | translate }}\"\n    (blur)=\"onTextInputBlur()\"\n  ></sol-text-input>\n  <div class=\"time-list-container\" *ngIf=\"alwaysOpen\" #timeOptionsContainer>\n    <div\n      #timeOptions\n      *ngFor=\"let time of getOptions(); let i = index\"\n      class=\"time-options\"\n      [attr.id]=\"'time-option-' + (i + 1)\"\n      (keydown)=\"handleKeyboardEvent($event)\"\n      [tabindex]=\"i == 0 ? 0 : -1\"\n      (click)=\"selectedTime(time)\"\n      [ngClass]=\"{ 'selected-item': selectedTimeString === time }\"\n      [attr.aria-label]=\"time\"\n    >\n      <span>{{ time }}</span>\n    </div>\n  </div>\n  <sol-time-picker-list\n    #openOverlay\n    [timeListOptions]=\"getOptions()\"\n    [overlayStatus]=\"showOverlay\"\n    [selectedTimeString]=\"selectedTimeString\"\n    (selectedListTime)=\"selectedTime($event)\"\n    (closed)=\"focusInput()\"\n  ></sol-time-picker-list>\n</div>\n",
      styles: [".sol-time-picker{display:flex;flex-direction:column;height:100%}.sol-time-picker .overlay-icon{outline:none;cursor:pointer}.sol-time-picker .overlay-icon:focus-visible{outline:1px solid #5804ff;outline-offset:2px}.sol-time-picker .time-list-container{width:100%;cursor:pointer;background-color:var(--color-button-basic-normal);overflow-y:scroll}.sol-time-picker .time-list-container .time-options{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body3-font-size);font-weight:var(--typography-opensans-body-body4-font-weight);padding:.625rem .75rem;margin:4px;border-radius:4px}.sol-time-picker .time-list-container .time-options:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.sol-time-picker .time-list-container .time-options.selected-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.sol-time-picker .time-list-container .time-options.selected-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container{border-color:var(--color-interface-border1);border-width:1px;border-style:solid;max-height:12.25rem;padding:.25rem .25rem .25rem .5rem;font-weight:var(--typography-opensans-body-body4-font-weight);cursor:pointer;background-color:var(--color-button-basic-normal);border-radius:4px;width:100%;overflow-y:scroll;box-shadow:0 8px 12px 1px #ab535333}.time-options-list-container .time-options-list{font-family:var(--typography-opensans-body-subtitle2-font-family);font-size:var(--typography-opensans-body-body1-font-size);color:var(--color-interface-text700);padding:.6875rem 1rem;border-radius:4px;margin-bottom:.25rem}.time-options-list-container .time-options-list:last-child{margin-bottom:0}.time-options-list-container .time-options-list:hover{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:active{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list:focus-visible{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size);outline:1px solid #5804ff;outline-offset:3px}.time-options-list-container .time-options-list.selected-list-item{background-color:var(--color-interface-background50);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:hover{background-color:var(--color-interface-background100);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}.time-options-list-container .time-options-list.selected-list-item:active{background-color:var(--color-interface-background125);color:var(--color-interface-text700);font-weight:var(--typography-opensans-body-subtitle2-font-weight);font-size:var(--typography-opensans-body-subtitle2-font-size)}*{scrollbar-width:thin;scrollbar-color:var(--color-globalstate-active-border) transparent}*::-webkit-scrollbar{width:8px}*::-webkit-scrollbar-corner{display:none}*::-webkit-scrollbar-track{background:transparent;background-clip:content-box;border-radius:5pt;border:3pt solid transparent}*::-webkit-scrollbar-thumb{background-color:var(--color-globalstate-active-border);border-radius:5pt;border:2pt solid transparent;background-clip:content-box}*::-webkit-scrollbar-thumb:vertical:hover{background:var(--color-globalstate-active-border);border-radius:5pt;border:none}* ::-webkit-scrollbar-track:vertical:hover{background:transparent;border:none}\n"]
    }]
  }], () => [{
    type: i0.ChangeDetectorRef
  }, {
    type: i0.ElementRef,
    decorators: [{
      type: Inject,
      args: [ElementRef]
    }]
  }, {
    type: i1$1.TranslationService
  }], {
    format: [{
      type: Input
    }],
    minTime: [{
      type: Input
    }],
    maxTime: [{
      type: Input
    }],
    steps: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    disableTextInput: [{
      type: Input
    }],
    alwaysOpen: [{
      type: Input
    }],
    timeChanged: [{
      type: Output
    }],
    timePicker: [{
      type: ViewChild,
      args: ['timePicker', {
        static: false
      }]
    }],
    timesOptionEl: [{
      type: ViewChildren,
      args: ['timeOptions']
    }],
    timeOptionsContainer: [{
      type: ViewChild,
      args: ['timeOptionsContainer']
    }],
    textInputEl: [{
      type: ViewChild,
      args: [TextInputComponent]
    }],
    timePickerList: [{
      type: ViewChild,
      args: [TimePickerListComponent]
    }]
  });
})();
class TimePickerModule {
  static {
    this.ɵfac = function TimePickerModule_Factory(t) {
      return new (t || TimePickerModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: TimePickerModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [TextInputModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), CommonModule, OverlayModule, TranslationModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TimePickerModule, [{
    type: NgModule,
    args: [{
      declarations: [TimePickerComponent, TimePickerDirective, TimePickerListComponent],
      imports: [TextInputModule, FormsModule.withConfig({
        callSetDisabledState: 'whenDisabledForLegacyCode'
      }), CommonModule, OverlayModule, TranslationModule],
      exports: [TimePickerComponent, TimePickerDirective, TimePickerListComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of tabs
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TimePickerComponent, TimePickerDirective, TimePickerListComponent, TimePickerModule };
